import { render, staticRenderFns } from "./AddSubAccountModal.vue?vue&type=template&id=b2f7b0b2&"
import script from "./AddSubAccountModal.vue?vue&type=script&lang=js&"
export * from "./AddSubAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports